import type { Device, Room } from '../../types/db';

export const rooms: Room[] = [
  { id: 'werkkamer', name: 'Werkkamer', presence: 'stil aanwezig', temp: 20, target: 20, light: 70, co2: 640 },
  { id: 'woonkamer', name: 'Woonkamer', presence: 'leeg', temp: 19.5, target: 20, light: 0, co2: 520 },
  { id: 'keuken', name: 'Keuken', presence: 'leeg', temp: 19, target: 19, light: 0, co2: 560 },
  { id: 'slaapkamer', name: 'Slaapkamer', presence: 'leeg', temp: 17, target: 17, light: 0, co2: 1080 },
  { id: 'badkamer', name: 'Badkamer', presence: 'leeg', temp: 21, target: 21, light: 0, co2: 480 },
  { id: 'gang', name: 'Gang', presence: 'leeg', temp: 18, target: 18, light: 0, co2: 500 },
];

export const devices: Device[] = [
  { id: 'koffie', roomId: 'keuken', name: 'Koffiezetapparaat', kind: 'koffie', status: 'uit' },
  {
    id: 'cam-voordeur',
    roomId: 'gang',
    name: 'Deurbelcamera',
    kind: 'camera',
    status: 'Bezorger met een pakket',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f6184a7f-30e0-4610-b3a3-11970899efba.jpg',
    privacyMask: 'straat en buren',
    maskHeight: 0.2,
    detection: { label: 'Bezorger', confidence: 0.94, box: [0.41, 0.215, 0.2, 0.69] },
  },
  { id: 'slot-voordeur', roomId: 'gang', name: 'Slot voordeur', kind: 'slot', status: 'op slot' },
  { id: 'alarm', roomId: 'gang', name: 'Alarm', kind: 'alarm', status: 'uit' },
  { id: 'water-keuken', roomId: 'keuken', name: 'Watersensor vaatwasser', kind: 'watersensor', status: 'droog' },
];
